import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 0,
  class: "` absolute transform z-20 left-7 top-1/2 -translate-y-1/2 h-0.5 w-12 sm:top-7 sm:left-1/2 sm:translate-y-0 sm:-translate-x-1/2 sm:w-0.5 sm:h-12 `",
  style: {"background":"#DDDDEC"}
}
const _hoisted_3 = ["src"]

import { computed, ref, onMounted } from 'vue'
import arrowDownSvg from '../images/arrow-down.svg'

interface EmitInterface {
  (e: 'touchIndex', num: number): void
  (e: 'toArchitecture'): void
}

// eslint-disable-next-line no-unused-vars

export default /*#__PURE__*/_defineComponent({
  props: {
    distancePercents: null
  },
  emits: ["touchIndex", "toArchitecture"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'touchIndex', num: number): void
  (e: 'toArchitecture'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  distancePercents: number[]
}





const windowWidth = ref(document.documentElement.offsetWidth)

const nums = 4
const activeN = computed(() => {
  let n = 1
  props.distancePercents.forEach((v, index) => {
    // 不要到2，确保点击后，点亮圆圈
    if (v >= 1.99) {
      n = index + 2
    }
  })
  return n
})

const lineHeights = computed(() => {
  return props.distancePercents.map(v => {
    return (v / 2) * 100 + '%'
  })
})

const hideProcessBar = computed(() => {
  return (props.distancePercents.every(v => {
    return v === 0
  }) || props.distancePercents.every((v, index) => {
    if (index < props.distancePercents.length - 1) {
      return v === 2
    // 最后一个特性，滚动到一半，隐藏这个bar
    } else {
      return v >= 1
    }
  }))
})

onMounted(() => {
  window.addEventListener('resize', () => {
    windowWidth.value = document.documentElement.offsetWidth
  })
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "` fixed transform flex items-center justify-center bottom-10 right-1/2 translate-x-1/2 flex-row sm:right-14 sm:bottom-1/2 sm:translate-y-1/2 sm:flex-col `",
      style: _normalizeStyle(`opacity:${_unref(hideProcessBar) ? '0' : '1'}`)
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(nums, (n) => {
        return _createElementVNode("div", {
          key: n,
          class: "` dot-wrapper w-10 h-10 rounded-full flex items-center justify-center relative cursor-pointer flex-row mr-6 last:mr-0 sm:flex-col sm:mb-6 sm:mr-0 last:mb-0 `",
          onClick: ($event: any) => (_ctx.$emit('touchIndex', n - 1))
        }, [
          _createElementVNode("div", {
            style: {"background-color":"rgba(221, 221, 236, 1)"},
            class: _normalizeClass(["dot-circle w-10 h-10 rounded-full absolute top-0 left-0 z-10 transform transition-transform transition-opacity duration-300", _unref(activeN) === n ? 'opacity-100 scale-100' : 'opacity-0 scale-0'])
          }, null, 2),
          (n !== 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: "h-full sm:w-full",
                  style: _normalizeStyle(`background:#373653;${windowWidth.value < 640 ? 'width:' : 'height:'}${_unref(lineHeights)[n - 1]};`)
                }, null, 4)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "dot w-2.5 h-2.5 rounded-full relative z-30 transition-colors duration-300",
            style: _normalizeStyle(`${_unref(activeN) > n - 1 ? 'background:#373653;' : 'background:#DDDDEC;'}`)
          }, null, 4)
        ], 8, _hoisted_1)
      }), 64))
    ], 4),
    _createElementVNode("div", {
      class: "w-10 h-10 fixed transform flex items-center justify-center bottom-10 right-1/2 translate-x-1/2 flex-row cursor-pointer hidden sm:block",
      style: _normalizeStyle(`opacity:${_unref(hideProcessBar) ? '0' : '1'}`),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toArchitecture')))
    }, [
      _createElementVNode("img", {
        src: _unref(arrowDownSvg),
        class: "w-10 h-10 block animate-bounce-slow"
      }, null, 8, _hoisted_3)
    ], 4)
  ], 64))
}
}

})